import React from 'react'
import {toast} from 'react-hot-toast'

export default function Product(props) {
    
    return (
        <div className='row mt-3'>
      
            <div className='col-3'>
                <h5> {props.productList.name}<span className="badge bg-secondary ms-3">₹{props.productList.price}</span></h5>
            </div>
            <div className="col-3">
                <div className="btn-group" role="group" aria-label="Basic mixed styles example">
                    <button type="button" className="btn btn-danger" onClick={() =>
                        {
                            props.decrementQuantity(props.index)
                        }
                    }>
                        -</button>
                    <button type="button" className="btn btn-warning">
                        {props.productList.Quantity}</button>
                    <button type="button" className="btn btn-success" onClick={() =>
                        {
                            props.incrementQuantity(props.index)
                        }
                    }>
                        +</button>
                </div>
            </div>
            <div className="col-2 price">
               <h5>₹{props.productList.Quantity*props.productList.price}</h5> 
            </div>
            <button className='col-3 btn btn-danger' onClick={() =>
                        {
                            props.removeItem(props.index);
                            toast.success("Removed the Item!!");
                        }
                    }>Remove</button>
        </div>
    )
}
